import axios from './auth'

// const SR_BASE_URL = `http://localhost:8044/api`
const SR_BASE_URL = `${process.env.VUE_APP_API_BASE_URL}/sr`
const user_id = localStorage.getItem('profile')
  ? JSON.parse(localStorage.getItem('profile'))?.id
  : null

function axiosSr(config) {
  return axios({
    ...config,
    params: {
      ...config.params,
      user_id,
    },
  })
}

export const state = {}

export const getters = {}

export const mutations = {}

export const actions = {
  // GET
  async fetchListDepartment({ commit }, params) {
    const url = `${SR_BASE_URL}/list-department`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async fetchListServiceAndRepair({ commit }, params) {
    const url = `${SR_BASE_URL}/service-list`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchListVehicleType({ commit }, params) {
    const url = `${SR_BASE_URL}/vehicle-list-type`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchListTableServiceAndRepair({ commit }, params) {
    const url = `${SR_BASE_URL}/service-list-table`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async fetchListProgressTableServiceAndRepair({ commit }, params) {
    const url = `${SR_BASE_URL}/service-list-table-progress`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  async fetchListTableFinishedServiceAndRepair({ commit }, params) {
    const url = `${SR_BASE_URL}/service-list-table-finished`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchListTableFinishedServiceAndRepairById({ commit }, params) {
    const url = `${SR_BASE_URL}/service-list-table-finished/${params.id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchDetailRepairServiceAndRepair({ commit }, payload) {
    const url = `${SR_BASE_URL}/service-detail-repair-finished/${payload.id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchSingleServiceAndRepair({ commit }, params = {}) {
    const url = `${SR_BASE_URL}/service-list/${params.id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchSingleRepair({ commit }, params = {}) {
    const url = `${SR_BASE_URL}/view-job/${params.id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: params.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchListRepairService({ commit }, payload) {
    const url = `${SR_BASE_URL}/options-jobs/${payload.id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchLogs({ commit }, payload) {
    const url = `${SR_BASE_URL}/logs/${payload?.id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload?.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchListVehicles({ commit }, params) {
    const url = `${SR_BASE_URL}/vehicle-list`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async getTargetAvailability({ commit }, params) {
    const url = `${SR_BASE_URL}/target-availabilities`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async getTargetAvailabilityNew({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availabilities/target`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.body,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async getTargetAvailabilityPlan({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availabilities/plan`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.body,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async getTargetAvailabilityPlanYearlyVehicle({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availability/vehicle/list`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.body,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async getTargetAvailabilityPlanYearlyCategory({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availability/category/list`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.body,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async getMaintenanceComponent({ commit }, payload) {
    const url = `${SR_BASE_URL}/maintenance-components/${payload.vehicle_id}`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.body,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  // EXSPORT IMPORT
  async getTemplateTargetAv({ commit }, params) {
    const url = `${SR_BASE_URL}/target-availabilities/import-template`
    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
      responseType: 'blob',
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  // New: direct GET for target-availability/import-template (without using target-availabilities path)
  async getTemplateTargetAvDirect({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availability/import-template`
    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload?.params,
      responseType: 'blob',
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response?.data || e,
      }
    }
  },
  async exportTargetAvailabilityCategory({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availability/category/export`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload.params,
      data: payload.body,
      responseType: 'blob',
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response?.data || e,
      }
    }
  },
  async exportTargetAvailability({ commit }, payload) {
    const exportPath =
      payload?.body?.export_path || 'target-availabilities/export'
    if (payload?.body?.export_path) {
      delete payload.body.export_path
    }
    const url = `${SR_BASE_URL}/${exportPath}`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload.params,
      data: payload.body,
      responseType: 'blob',
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async importTargetAvailability({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availabilities/import`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload.params,
      data: payload.body,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  // New: direct POST to target-availability/import without using the old helper
  async importTargetAvailabilityDirect({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availability/import`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload?.params,
      data: payload?.body,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response?.data || e,
      }
    }
  },

  // Technical Dashboard Export
  async exportTechnicalPercentageFleetAvailabilityYearly({ commit }, payload) {
    const url = `${SR_BASE_URL}/dashboard/technical/percentage-fleet-availability-yearly/export`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload.params,
      data: payload.body,
      responseType: 'blob',
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response?.data || e,
      }
    }
  },

  // GET MASTERS
  async fetchMasterActivity({ commit }, params) {
    const url = `${SR_BASE_URL}/master-activity`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchMasterCategory({ commit }, params) {
    const url = `${SR_BASE_URL}/master-category`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchMasterCause({ commit }, params) {
    const url = `${SR_BASE_URL}/master-cause`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchMasterClassification({ commit }, params) {
    const url = `${SR_BASE_URL}/master-classification`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchMasterKindTask({ commit }, params) {
    const url = `${SR_BASE_URL}/master-kind-task`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchMasterStatus({ commit }, params) {
    const url = `${SR_BASE_URL}/master-status`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchMasterTaskType({ commit }, params) {
    const url = `${SR_BASE_URL}/master-task-type`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchMasterReasonProject({ commit }, params) {
    const url = `${SR_BASE_URL}/master-reject-reason`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  // CRUD MASTERS
  async getMasterCategory({ commit }, params) {
    const url = `${SR_BASE_URL}/master-category`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async createMasterCategory({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-category`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async updateMasterCategory({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-category/${payload.id}`

    const method = 'put'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async deleteMasterCategory({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-category/${payload.id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },

  async getMasterActivity({ commit }, params) {
    const url = `${SR_BASE_URL}/master-activity`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async createMasterActivity({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-activity`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async updateMasterActivity({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-activity/${payload.id}`

    const method = 'put'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async deleteMasterActivity({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-activity/${payload.id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },

  async getMasterCause({ commit }, params) {
    const url = `${SR_BASE_URL}/master-cause`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async createMasterCause({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-cause`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async updateMasterCause({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-cause/${payload.id}`

    const method = 'put'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async deleteMasterCause({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-cause/${payload.id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },

  async getMasterClassification({ commit }, params) {
    const url = `${SR_BASE_URL}/master-classification`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async createMasterClassification({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-classification`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async updateMasterClassification({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-classification/${payload.id}`

    const method = 'put'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async deleteMasterClassification({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-classification/${payload.id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },

  async getMasterKindTask({ commit }, params) {
    const url = `${SR_BASE_URL}/master-kind-task`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async createMasterKindTask({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-kind-task`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async updateMasterKindTask({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-kind-task/${payload.id}`

    const method = 'put'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async deleteMasterKindTask({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-kind-task/${payload.id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },

  async getMasterTaskType({ commit }, params) {
    const url = `${SR_BASE_URL}/master-task-type`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async createMasterTaskType({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-task-type`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async updateMasterTaskType({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-task-type/${payload.id}`

    const method = 'put'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async deleteMasterTaskType({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-task-type/${payload.id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },

  async getMasterRejectReason({ commit }, params) {
    const url = `${SR_BASE_URL}/master-reject`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async createMasterRejectReason({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-reject`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async updateMasterRejectReason({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/master-reject/${payload.id}`

    const method = 'put'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },

  // SR FILE
  async deleteFileSr({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/files`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.body,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },

  // GET REPORT
  async fetchReportDashboard({ commit }, params) {
    const url = `${SR_BASE_URL}/report-dashboard`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchReportDashboardGraphics({ commit }, params) {
    const url = `${SR_BASE_URL}/report-dashboard-graphics`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchReportDashboardPies({ commit }, params) {
    const url = `${SR_BASE_URL}/report-dashboard-pies`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchReportDashboardTables({ commit }, params) {
    const url = `${SR_BASE_URL}/report-dashboard-tables`

    const method = 'get'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchReportAvailabilityDashboard({ commit }, payload) {
    const url = `${SR_BASE_URL}/dashboard/technical/availability-and-breakdown-report`
    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.body,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchReportPlanEmergencyDashboard({ commit }, payload) {
    const url = `${SR_BASE_URL}/dashboard/technical/plan-and-emergency`
    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.body,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchReportFleetAvailabilityDashboard({ commit }, payload) {
    const url = `${SR_BASE_URL}/dashboard/technical/percentage-fleet-availability`
    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.body,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchReportFleetAvailabilityDashboardYearly({ commit }, payload) {
    const url = `${SR_BASE_URL}/dashboard/technical/percentage-fleet-availability-yearly`
    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.body,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },
  async fetchPlanEmergencyDetail({ commit }, payload) {
    const url = `${SR_BASE_URL}/dashboard/technical/plan-and-emergency/detail`
    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.body,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: 'error',
        data: e.response.data,
      }
    }
  },

  // POST
  async createServiceAndRepair({ commit }, payload) {
    const url = `${SR_BASE_URL}/service`
    console.log('paramsasdasdasd', payload.params)
    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async updateServiceAndRepair({ commit }, payload) {
    const url = `${SR_BASE_URL}/update-jobs`
    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload?.data,
      params: payload?.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async createJobs({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/create-jobs/${payload.id}`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.formData,
      params: payload?.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async updateJobs({ commit }, formData) {
    const url = `${SR_BASE_URL}/update-jobs?user_id=${formData.user_id}`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: formData,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async setReviewRepair({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/review-repair/${payload.id}`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.formData,
      params: payload?.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async setActivityRepair({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/activity-repair/${payload.id}`
    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.formData,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data,
      }
    }
  },
  async setRejectService({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/reject-service/${payload.id}`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async setCloseService({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/close-service/${payload.id}`
    console.log(payload)

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async checkVehicleExist({ commit }, payload) {
    const url = `${SR_BASE_URL}/check-vehicle/${payload.id}`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async createTargetAvailabilities({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availabilities?user_id=${payload.user_id}`
    
    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
        ...e
      }
    }
  },
  async updateTargetAvailability({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availabilities/${payload.id}`

    const method = 'put'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async deleteTargetAvailability({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availabilities/bulk-delete`

    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },

  // Target Availability Yearly (VEHICLE)
  async createTargetAvailabilityYearlyVehicle({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availability/vehicle?user_id=${payload.user_id}`
    
    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async deleteTargetAvailabilityYearlyVehicle({ commit }, id) {
    const url = `${SR_BASE_URL}/target-availability/vehicle/${id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async updateTargetAvailabilityYearlyVehicle({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availability/vehicle/${payload.id}`
    
    const method = 'put'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  // Target Availability Yearly (CATEGORY)
  async createTargetAvailabilityYearlyCategory({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availability/category?user_id=${payload.user_id}`
    
    const method = 'post'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async deleteTargetAvailabilityYearlyCategory({ commit }, id) {
    const url = `${SR_BASE_URL}/target-availability/category/${id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async updateTargetAvailabilityYearlyCategory({ commit }, payload) {
    const url = `${SR_BASE_URL}/target-availability/category/${payload.id}`
    
    const method = 'put'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },

  // PUT
  async approveSr({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/approve-sr/${payload.id}`

    const method = 'put'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload.data,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },

  // DELETE
  async deleteService({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/delete-service/${payload.id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async deleteRepair({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/delete-repair/${payload.id}`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async requestDeleteSr({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/request-delete/${payload.id}`

    const method = 'put'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      params: payload?.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      return {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
  async deleteJobsBulk({ commit }, payload = {}) {
    const url = `${SR_BASE_URL}/delete-repair/bulk`

    const method = 'delete'
    const headers = {}
    const config = {
      url,
      method,
      headers,
      data: payload?.data,
      params: payload?.params,
    }

    try {
      const response = await axiosSr(config)
      let data = response.data
      return {
        status: 'success',
        data,
      }
    } catch (e) {
      throw {
        status: e.response.status,
        data: e.response.data.data,
      }
    }
  },
}
